import { C1TypographyVariants } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const textfieldStyles: moduleStyleType = {
    h1: {
        '& .MuiInputBase-root input': C1TypographyVariants.h1,
    },
    h2: {
        '& .MuiInputBase-root input': C1TypographyVariants.h2,
    },
    h3: {
        '& .MuiInputBase-root input': C1TypographyVariants.h3,
    },
    h4: {
        '& .MuiInputBase-root input': C1TypographyVariants.h4,
    },
    h5: {
        '& .MuiInputBase-root input': C1TypographyVariants.h5,
    },
    h6: {
        '& .MuiInputBase-root input': C1TypographyVariants.h6,
    },
    subtitle1: {
        '& .MuiInputBase-root input': C1TypographyVariants.subtitle1,
    },
    subtitle2: {
        '& .MuiInputBase-root input': C1TypographyVariants.subtitle2,
    },
    body1: {
        '& .MuiInputBase-root input': C1TypographyVariants.body1,
    },
    body2: {
        '& .MuiInputBase-root input': C1TypographyVariants.body2,
    },
    fieldLabel: {
        mb: 1,
        fontSize: '14px',
        fontWeight: 500,
    },
}
